/*検査5
**16ページ
*/
const answer={
    1:"A",
    2:"B",
    3:"D",
    4:"D",
    5:"A",
    6:"B",
    
    
    // 17ページ
    
    7:"D",
    8:"B",
    9:"A",
    10:"D",
    11:"B",
    12:"A",
    
    
    //18ページ
    
    13:"C",
    14:"C",
    15:"D",
    16:"C",
    17:"B",
    18:"B",
    
    
    // 19ページ
    
    19:"A",
    20:"D",
    21:"C",
    22:"C",
    23:"C",
    24:"A",
    };

    export default answer;